module.exports = __webpack_public_path__ + "media/images/team__cleeksgc-a61a1b4dea991a02c4861fc0b14bd82a.png";